import { gql } from "@apollo/client";
import MultiValuesField from "controls/MultiValuesField";
import SwitchInput from "inputs/SwitchInput";
import TextInput from "inputs/TextInput";
import React from "react";
import ReadminObjectInput from "readmin_pages/shared/ReadminObjectInput";

export const VenueAdminsFormFragment = gql`
  fragment VenueAdminsFormFragment on VenueAdmin {
    id
    venue {
      id
    }
    email
    notifyOutages
  }
`;

export default function VenueAdminsForm({ venueAdmins = [{}] }) {
  venueAdmins = venueAdmins.map((ca) => ({
    notifyOutages: true,
    ...ca,
  }));

  return (
    <>
      <MultiValuesField
        label="Venue"
        name="venue"
        required
        defaultValues={venueAdmins.map((ca) => ca.venue)}
        disabled={!!venueAdmins.some((ca) => ca.id)}
        input={<ReadminObjectInput optionsTypename="Venue" />}
      />
      <MultiValuesField
        label="Email"
        name="email"
        required
        defaultValues={venueAdmins.map((ca) => ca.email)}
        disabled={venueAdmins.some((ca) => ca.id)}
        input={<TextInput autoComplete="email" type="email" />}
      />
      <MultiValuesField
        label="Notify Outages"
        name="notifyOutages"
        defaultValues={venueAdmins.map((ca) => ca.notifyOutages)}
        input={<SwitchInput />}
        helperText="Send an outage email when any device has outage for more than 1 hour affecting any courts."
      />
    </>
  );
}
